import React, {ComponentType} from 'react';
import {Meta, Story} from '@storybook/react';
import {ArgTypes} from '@storybook/addons/dist/ts3.9/types';
import {setLocale} from 'yup';
import {LocaleFR} from '../locale/validation-locale';
import {LOGIN_MODE_EXPLICIT} from '../app-provider/apollo-client';
import {BaseAppProviderProps, ComponentWrapper} from '@betrue/common-front';

export const StoryBookWrapper = (
  COMPONENT: (any) => JSX.Element,
  AppProvider: (props: BaseAppProviderProps) => JSX.Element,
  args: any,
  parameters: any = {},
  argTypes: ArgTypes = {},
  loginMode?: string
): { bindTemplate: ComponentType; story: Meta } => {
  setLocale(LocaleFR);

  const Template: Story<any> = (args) => (
    <>
      <style>
        @import url("https://fonts.googleapis.com/icon?family=Material+Icons"); @import
        url("https://fonts.googleapis.com/css2?family=Montserrat+Alternates:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,700;1,800&display=swap");
      </style>
      <ComponentWrapper appProvider={AppProvider}
                        loginMode={loginMode ? loginMode : (args?.loginMode ? args?.loginMode : LOGIN_MODE_EXPLICIT)}>
        <COMPONENT {...args} />
      </ComponentWrapper>
    </>
  );
  const bound = Template.bind({});
  bound.args = args;
  bound.parameters = parameters;
  return {
    bindTemplate: bound,
    story: {
      component: COMPONENT,
      title: COMPONENT.name,
      argTypes: argTypes,
    } as Meta,
  };
};
